!function (e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"));else if ("function" === typeof define && define.amd) define(["react"], t);else {
    var n = t("object" === typeof exports ? require("react") : e.react);

    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 2);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(5)();
  }, function (e, t, n) {
    e.exports = n(3);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(4);
    t.default = r.a;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var u = n(0),
        a = n.n(u),
        s = n(1),
        c = n.n(s),
        l = n(9),
        f = n(12),
        p = n(15),
        h = (n.n(p), function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }()),
        d = function (e) {
      function t() {
        var e, n, i, u;
        r(this, t);

        for (var a = arguments.length, s = Array(a), c = 0; c < a; c++) {
          s[c] = arguments[c];
        }

        return n = i = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), i.state = {
          query: null,
          open: !1,
          selected: null,
          value: ""
        }, i._suggestions = {}, i.onSuggestions = function (e, t) {
          i._suggestions[t] = e, i.suggestions = Object(l.a)(i.props.indexes.map(function (e) {
            return e.source.indexName;
          }), i._suggestions), i.setState({
            open: !0
          });
        }, i.onSuggestionClick = function (e, t) {
          i.props.onSelectionChange && i.props.onSelectionChange(e, t);
          var n = i.props.indexes.find(function (e) {
            return e.source.indexName === t;
          }).displayKey;
          i.setState({
            open: !1,
            value: e[n]
          });
        }, i.onKeyDown = function (e) {
          var t = i.state.selected;

          switch (e.key) {
            case "ArrowDown":
              t = i.suggestions.next(), e.preventDefault();
              break;

            case "ArrowUp":
              t = i.suggestions.prev(), e.preventDefault();
              break;

            case "ArrowRight":
              t = i.suggestions.nextCategory() || t, e.preventDefault();
              break;

            case "ArrowLeft":
              t = i.suggestions.prevCategory() || t, e.preventDefault();
              break;

            case "Escape":
              i.setState({
                open: !1
              }), e.preventDefault();
              break;

            case "Enter":
              i.onSuggestionClick(i.suggestions.current, i.suggestions.current.category), e.preventDefault();
              break;

            default:
              return;
          }

          i.setState({
            selected: t
          });
        }, i.updateQuery = function (e) {
          return i.setState({
            query: e.target.value,
            value: e.target.value
          });
        }, u = n, o(i, u);
      }

      return i(t, e), h(t, [{
        key: "renderChildren",
        value: function value() {
          var e = this,
              t = this.state.value;
          return a.a.Children.map(this.props.children, function (n) {
            if ("input" === n.key) return a.a.cloneElement(n, {
              onKeyDown: e.onKeyDown,
              onChange: e.updateQuery,
              value: t
            });
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = {};
          return this.state.open || (t.display = "none"), a.a.createElement("div", {
            className: "algolia-react-autocomplete"
          }, a.a.createElement("div", {
            className: "aa-input-container"
          }, this.renderChildren()), a.a.createElement("div", {
            className: "aa-dropdown-menus",
            style: t
          }, this.props.indexes.map(function (t) {
            return a.a.createElement(f.a, {
              key: t.source.indexName,
              indexName: t.source.indexName,
              query: e.state.query,
              index: t,
              selected: e.state.selected,
              onSuggestions: e.onSuggestions,
              onClick: e.onSuggestionClick
            });
          })));
        }
      }]), t;
    }(a.a.PureComponent);

    d.propTypes = {
      indexes: c.a.arrayOf(c.a.shape({
        source: c.a.shape({
          indexName: c.a.string.isRequired
        }).isRequired,
        displayKey: c.a.string.isRequired
      })),
      onSelectionChange: c.a.func,
      children: function children(e) {
        return a.a.Children.toArray(e.children).some(function (e) {
          return ".$input" === e.key;
        }) ? null : new Error('Expecting a child with key="input": <input type="search" key="input" />');
      }
    }, d.defaultProps = {
      indexes: []
    }, t.a = d;
  }, function (e, t, n) {
    "use strict";

    var r = n(6),
        o = n(7),
        i = n(8);

    e.exports = function () {
      function e(e, t, n, r, u, a) {
        a !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    function r(e, t, n, r, i, u, a, s) {
      if (o(t), !e) {
        var c;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [n, r, i, u, a, s],
              f = 0;
          c = new Error(t.replace(/%s/g, function () {
            return l[f++];
          })), c.name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    }

    var o = function o(e) {};

    e.exports = r;
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = n(10),
        o = n.n(r),
        i = function i(e, t) {
      return {
        list: o()(e.map(function (e) {
          return (t[e] || []).map(function (t) {
            return Object.assign({}, t, {
              category: e
            });
          });
        })),
        currentIndex: -1,

        get current() {
          return this.list[this.currentIndex];
        },

        next: function next() {
          return this.list.length ? (this.currentIndex = (this.currentIndex + 1) % this.list.length, this.list[this.currentIndex].objectID) : null;
        },
        prev: function prev() {
          return this.list.length ? (this.currentIndex < 1 && (this.currentIndex = this.list.length), this.currentIndex = this.currentIndex - 1, this.list[this.currentIndex].objectID) : null;
        },
        nextCategory: function nextCategory() {
          if (!this.list[this.currentIndex]) return null;
          var t = this.list[this.currentIndex].category,
              n = e.findIndex(function (e) {
            return e === t;
          }) + 1;
          if (n > e.length - 1) return null;
          var r = e[n],
              o = this.list.findIndex(function (e) {
            return e.category === r;
          });
          return -1 === o ? null : (this.currentIndex = o, this.list[this.currentIndex].objectID);
        },
        prevCategory: function prevCategory() {
          if (!this.list[this.currentIndex]) return null;
          var t = this.list[this.currentIndex].category,
              n = e.findIndex(function (e) {
            return e === t;
          }) - 1;
          if (n < 0) return null;
          var r = e[n],
              o = this.list.findIndex(function (e) {
            return e.category === r;
          });
          return -1 === o ? null : (this.currentIndex = o, this.list[this.currentIndex].objectID);
        }
      };
    };

    t.a = i;
  }, function (e, t, n) {
    (function (t) {
      function n(e, t) {
        for (var n = -1, r = t.length, o = e.length; ++n < r;) {
          e[o + n] = t[n];
        }

        return e;
      }

      function r(e, t, i, u, a) {
        var s = -1,
            c = e.length;

        for (i || (i = o), a || (a = []); ++s < c;) {
          var l = e[s];
          t > 0 && i(l) ? t > 1 ? r(l, t - 1, i, u, a) : n(a, l) : u || (a[a.length] = l);
        }

        return a;
      }

      function o(e) {
        return I(e) || u(e) || !!(k && e && e[k]);
      }

      function i(e) {
        return (e ? e.length : 0) ? r(e, 1) : [];
      }

      function u(e) {
        return s(e) && j.call(e, "callee") && (!O.call(e, "callee") || w.call(e) == d);
      }

      function a(e) {
        return null != e && l(e.length) && !c(e);
      }

      function s(e) {
        return p(e) && a(e);
      }

      function c(e) {
        var t = f(e) ? w.call(e) : "";
        return t == y || t == g;
      }

      function l(e) {
        return "number" == typeof e && e > -1 && e % 1 == 0 && e <= h;
      }

      function f(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function p(e) {
        return !!e && "object" == typeof e;
      }

      var h = 9007199254740991,
          d = "[object Arguments]",
          y = "[object Function]",
          g = "[object GeneratorFunction]",
          v = "object" == typeof t && t && t.Object === Object && t,
          b = "object" == typeof self && self && self.Object === Object && self,
          m = v || b || Function("return this")(),
          x = Object.prototype,
          j = x.hasOwnProperty,
          w = x.toString,
          _ = m.Symbol,
          O = x.propertyIsEnumerable,
          k = _ ? _.isConcatSpreadable : void 0,
          I = Array.isArray;
      e.exports = i;
    }).call(t, n(11));
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" === typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
    }

    function i(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    var u = n(0),
        a = n.n(u),
        s = n(1),
        c = n.n(s),
        l = n(13),
        f = n.n(l),
        p = n(14),
        h = n.n(p),
        d = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        y = function y(e) {
      return new h.a(function (t, n) {
        e.then(t).catch(n);
      });
    },
        g = function (e) {
      function t() {
        var e, n, i, u;
        r(this, t);

        for (var s = arguments.length, c = Array(s), l = 0; l < s; l++) {
          c[l] = arguments[l];
        }

        return n = i = o(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(c))), i.state = {
          hits: []
        }, i.onQueryChange = function (e) {
          i._promise && i._promise.cancel(), i._promise = y(i.props.index.source.search(e, {})).then(function (e) {
            var t = e.hits;
            i.setState({
              hits: t
            }), i.props.onSuggestions(t, i.props.indexName);
          }).catch(function (e) {
            return i.setState({
              hits: []
            });
          });
        }, i.renderHit = function (e) {
          var t = i.props.index,
              n = t.source,
              r = t.templates,
              o = t.displayKey,
              u = i.props.selected === e.objectID;
          return a.a.createElement("div", {
            key: e.objectID,
            className: f()({
              "aa-suggestion": !0,
              selected: u
            }),
            role: "option",
            id: e.objectID,
            onClick: function onClick() {
              return i.props.onClick(e, n.indexName);
            },
            "aria-selected": u
          }, r && r.suggestion ? r.suggestion(e, u) : e[o]);
        }, u = n, o(i, u);
      }

      return i(t, e), d(t, [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          var t = e.query;
          this.props.query !== t && this.onQueryChange(t);
        }
      }, {
        key: "renderHeader",
        value: function value() {
          var e = this.props.index,
              t = e.source,
              n = e.templates;
          return n && n.header ? n.header() : a.a.createElement("div", {
            className: "aa-suggestions-category"
          }, t.indexName);
        }
      }, {
        key: "render",
        value: function value() {
          return a.a.createElement("span", {
            className: "aa-dropdown-menu",
            role: "listbox"
          }, this.renderHeader(), a.a.createElement("div", {
            className: "aa-suggestions"
          }, this.state.hits.map(this.renderHit)));
        }
      }]), t;
    }(a.a.PureComponent);

    g.propTypes = {
      index: c.a.shape({
        source: c.a.shape({
          indexName: c.a.string.isRequired
        }).isRequired,
        displayKey: c.a.string.isRequired,
        template: c.a.shape({
          header: c.a.func,
          suggestion: c.a.func
        })
      }).isRequired,
      selected: c.a.string,
      onSuggestions: c.a.func.isRequired,
      onClick: c.a.func.isRequired
    }, t.a = g;
  }, function (e, t, n) {
    var r, o;
    !function () {
      "use strict";

      function n() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var o = typeof r;
            if ("string" === o || "number" === o) e.push(r);else if (Array.isArray(r)) e.push(n.apply(null, r));else if ("object" === o) for (var u in r) {
              i.call(r, u) && r[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      var i = {}.hasOwnProperty;
      "undefined" !== typeof e && e.exports ? e.exports = n : (r = [], void 0 !== (o = function () {
        return n;
      }.apply(t, r)) && (e.exports = o));
    }();
  }, function (e, t, n) {
    "use strict";

    function r(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        i = function i(e, t, n, r) {
      try {
        e(n(r));
      } catch (e) {
        t(e);
      }
    },
        u = function () {
      function e(t) {
        r(this, e), this._promise = new Promise(t), this._canceled = !1;
      }

      return o(e, null, [{
        key: "all",
        value: function value(t) {
          return new e(function (e, n) {
            Promise.all(t).then(e, n);
          });
        }
      }, {
        key: "race",
        value: function value(t) {
          return new e(function (e, n) {
            Promise.race(t).then(e, n);
          });
        }
      }, {
        key: "reject",
        value: function value(t) {
          return new e(function (e, n) {
            Promise.reject(t).then(e, n);
          });
        }
      }, {
        key: "resolve",
        value: function value(t) {
          return new e(function (e, n) {
            Promise.resolve(t).then(e, n);
          });
        }
      }]), o(e, [{
        key: "then",
        value: function value(t, n) {
          var r = this,
              o = new e(function (e, u) {
            r._promise.then(function (n) {
              r._canceled && o.cancel(), t && !r._canceled ? i(e, u, t, n) : e(n);
            }, function (t) {
              r._canceled && o.cancel(), n && !r._canceled ? i(e, u, n, t) : u(t);
            });
          });
          return o;
        }
      }, {
        key: "catch",
        value: function value(e) {
          return this.then(void 0, e);
        }
      }, {
        key: "cancel",
        value: function value() {
          return this._canceled = !0, this;
        }
      }]), e;
    }();

    t.default = u;
  }, function (e, t) {}]);
});